import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { requestsReducer } from 'redux-requests';

const rootReducer = combineReducers({
	routing: routerReducer,
	requests: requestsReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./public/src/reducers/index.js